const guestIdKey = (roomUuid) => `chat_guest_id:${roomUuid}`;
const chatUuidKey = (roomUuid) => `chat_uuid:${roomUuid}`;
const CHAT_UUID_GLOBAL_KEY = "chat_uuid";

export const getStoredGuestId = (roomUuid) => {
  if (!roomUuid) return null;
  return localStorage.getItem(guestIdKey(roomUuid));
};

export const setStoredGuestId = (roomUuid, guestId) => {
  if (!roomUuid || !guestId) return;
  localStorage.setItem(guestIdKey(roomUuid), String(guestId));
};

/** chat_uuid from footer/qr-code or qr-code payloads (sent as socket qrCode). */
export const extractChatUuid = (data = {}) =>
  data?.chat_uuid ?? data?.chatUuid ?? null;

export const getStoredChatUuid = (roomUuid) => {
  if (roomUuid) {
    const keyed = localStorage.getItem(chatUuidKey(roomUuid));
    if (keyed) return keyed;
  }
  return localStorage.getItem(CHAT_UUID_GLOBAL_KEY);
};

export const setStoredChatUuid = (roomUuid, chatUuid) => {
  if (!chatUuid) return;
  const value = String(chatUuid);
  localStorage.setItem(CHAT_UUID_GLOBAL_KEY, value);
  if (roomUuid) {
    localStorage.setItem(chatUuidKey(roomUuid), value);
  }
};

export const extractHostId = (footerData = {}) =>
  footerData.host_id ?? footerData.hostId ?? null;

export const extractUnitName = (footerData = {}) =>
  footerData.name ??
  footerData.unit_name ??
  footerData.unitName ??
  footerData.room_number ??
  footerData.roomNumber ??
  "";
